import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    matchScheduleList: [],
    matchUpcomingList: [],
    matchPlayersList: [],
    allMatchesList: [],
    allContestList: [],
    liveMatchList: [],
    liveMatchBook: [],
    compliteMatchList: [],
}
const matchSlice = createSlice({
    name: 'FantacyMatchData',
    initialState: initialState,
    reducers: {
        saveScheduleList: (state, action) => {
            state.matchScheduleList = action.payload
        },
        saveUpcomingList: (state, action) => {
            state.matchUpcomingList = action.payload
        },
        saveMatchPlayersList: (state, action) => {
            state.matchPlayersList = action.payload
        },
        saveAllMatchesList: (state, action) => {
            state.allMatchesList = action.payload
        },
        saveAllContestList: (state, action) => {
            state.allContestList = action.payload
        },
        saveLiveMatchList: (state, action) => {
            state.liveMatchList = action.payload
        },
        saveLiveMatchBook: (state, action) => {
            state.liveMatchBook = action.payload
        },
        saveCompliteMatchList: (state, action) => {
            state.compliteMatchList = action.payload
        },
        resetMatchData: (state) => {
            Object.assign(state, initialState);
        }
    }
})

export const { resetMatchData, saveScheduleList, saveUpcomingList,saveMatchPlayersList,saveAllMatchesList,saveAllContestList,saveLiveMatchList,saveLiveMatchBook,saveCompliteMatchList } = matchSlice.actions;
export default matchSlice.reducer